import { ReactElement } from 'react';
import { AssetPositionTooltip } from '../../tooltips/asset-position-tooltip/AssetPositionTooltip';
import { SafetyAlertType } from '@casops/store/apis/commonModels';
import { useTranslation } from 'react-i18next';
import { useLocaleFormatter } from '@casops/shared/hooks/useLocaleFormatter';
import styles from './SafetyEventTooltip.module.scss';

export interface SafetyEventTooltipProps {
  ts: string;
  did: string;
  eventType: SafetyAlertType;
  tooltipPane?: string;
}

export const SafetyEventTooltip = ({
  ts,
  did,
  eventType,
  tooltipPane,
}: SafetyEventTooltipProps): ReactElement => {
  const { t } = useTranslation();
  const { showTimeAndDateFromIso } = useLocaleFormatter();

  const title =
    eventType === SafetyAlertType.Duress
      ? t('Model.Name.SafetyAlertDuress')
      : t('Model.Name.SafetyAlertManDown');

  return (
    <AssetPositionTooltip pane={tooltipPane} title={title}>
      <span className={styles.text}>{`${t('Fields.PPUID')} ${did}`}</span>
      <span className={styles.text}>{showTimeAndDateFromIso(ts)}</span>
    </AssetPositionTooltip>
  );
};
